import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
const CardRoot = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('rounded-[var(--radius-3)] border border-[var(--color-border-default)] bg-[var(--color-surface-raised)] text-[var(--color-text-primary)] shadow-sm', className), ...props })));
CardRoot.displayName = 'Card';
const CardHeader = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('flex items-start justify-between gap-4 p-6', className), ...props })));
CardHeader.displayName = 'Card.Header';
const CardTitle = React.forwardRef(({ className, ...props }, ref) => (_jsx("h3", { ref: ref, className: cn('text-base font-semibold leading-none tracking-tight', className), ...props })));
CardTitle.displayName = 'Card.Title';
const CardDescription = React.forwardRef(({ className, ...props }, ref) => (_jsx("p", { ref: ref, className: cn('text-sm text-[var(--color-text-muted)]', className), ...props })));
CardDescription.displayName = 'Card.Description';
const CardContent = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('p-6 pt-0', className), ...props })));
CardContent.displayName = 'Card.Content';
const CardFooter = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('flex items-center gap-2 p-6 pt-0', className), ...props })));
CardFooter.displayName = 'Card.Footer';
const CardAction = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('ml-auto flex items-center gap-2', className), ...props })));
CardAction.displayName = 'Card.Action';
export const Card = Object.assign(CardRoot, {
    Header: CardHeader,
    Title: CardTitle,
    Description: CardDescription,
    Content: CardContent,
    Footer: CardFooter,
    Action: CardAction,
});
//# sourceMappingURL=card.js.map